import React, { useEffect, useRef, useState } from "react";

const Tab = ({
  activeTab,
  setActiveTab,
  tabs,
  tabStyle,
  tabUnderlineBackground = "#000000",
  activeTabColor = "#000000",
  tabContainerStyle,
  tabButtonStyle,
}) => {
  const [tabUnderlineWidth, setTabUnderlineWidth] = useState(0);
  const [tabUnderlineLeft, setTabUnderlineLeft] = useState(0);

  const tabsRef = useRef([]);
  const containerRef = useRef(null);

  // Function to update underline position
  const updateUnderlinePosition = () => {
    const currentTab = tabsRef.current[activeTab];
    const container = containerRef.current;

    if (currentTab && container) {
      const containerScrollLeft = container.scrollLeft;
      setTabUnderlineLeft(currentTab.offsetLeft - containerScrollLeft);
      setTabUnderlineWidth(currentTab.clientWidth);
    }
  };

  useEffect(() => {
    updateUnderlinePosition();

    window.addEventListener("resize", updateUnderlinePosition);

    return () => window.removeEventListener("resize", updateUnderlinePosition);
  }, [activeTab]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", updateUnderlinePosition);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", updateUnderlinePosition);
      }
    };
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div style={tabStyle} className="relative border-b-[1px] border-black">
      <div
        style={tabContainerStyle}
        ref={containerRef}
        className="flex px-5 md:px-8 xl:px-0 scrollbar-hide items-center justify-between overflow-x-scroll w-full xl:w-[1000px] space-x-[50px] mx-auto"
      >
        {tabs.map((tab, idx) => (
          <div
            style={tabButtonStyle}
            key={tab.name}
            ref={(el) => (tabsRef.current[tab.name] = el)} // Store ref for each tab by name
            className="cursor-pointer h-[30px] flex min-w-fit"
            onClick={() => handleTabClick(tab.name)}
          >
            <div
              style={{
                color: activeTab === tab.name ? activeTabColor : "#000000",
                "--after-bg":
                  activeTab === tab.name ? tabUnderlineBackground : "#000000",
              }}
              className={
                activeTab === tab.name
                  ? "tab-item-active"
                  : "text-[16px] !flex-shrink-0"
              }
            >
              {tab.name}
            </div>
          </div>
        ))}
      </div>
      <span
        className="absolute hidden md:block bottom-0 h-[3px] transition-all duration-300"
        style={{
          left: tabUnderlineLeft,
          width: tabUnderlineWidth,
          background: tabUnderlineBackground,
        }}
      />
    </div>
  );
};

export default Tab;
